import { render } from "./MyTimesheet.vue?vue&type=template&id=f815ff80"
import script from "./MyTimesheet.vue?vue&type=script&lang=js"
export * from "./MyTimesheet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__